<template>
	<div class="pop-mask" v-if='isModalflag' @click="closeMask">
		<div class="mask-content" @click.stop="closeFlag">
			<span >下一章为付费章节，请订阅</span>
			<div class="">
				<span>订阅价格</span>
				<div class="">
					<span style="color: #F63232;">{{countCurrency}} </span>
					<span> 书币</span>
				</div>
			</div>
			<div class="">
				<span>剩余书币</span>
				<div class="">
					<span>{{userCurrency}}书币</span>
					<span v-if="countCurrency>userCurrency" style="font-size: 13px;color: #F63333;">（余额不足）</span>
				</div>
			</div>
			<div class="btn" @click.stop="gotoCharge">
				<span v-if="countCurrency<=userCurrency">确 认 订 阅</span>
				<span v-else>书币不足，点击充值</span>
			</div>
			<p class="tips" @click='changeStatus'><img :src="isauto==1?'../../../static/choosed.png':'../../../static/no-choose.png'" alt=""> <span>进入本书付费章节自动订阅</span></p>
		</div>
	</div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
	export default{
		props:{
			showAutoBuyMask:{
				type: Boolean,
				default: false
			},
			countCurrency:{
				type: Number,
				default: 0
			},
			userCurrency:{
				type: Number,
				default: 0
			},
			isOpen:{
				type:Number,
				default:0
			}
		},
		watch:{
			showAutoBuyMask(Vnew){
				// console.log(Vnew)
				this.isModalflag=Vnew;
			},
			countCurrency(Vnew){
				// console.log(Vnew)
			},
			userCurrency(Vnew){
				// console.log(Vnew)
			},
			isOpen(Vnew){
				console.log('...........'+Vnew)
				if(Vnew==1){
					this.isauto=1
				}
				
			}
			
		},
		data(){
			return {
				isModalflag:false,
				isauto:1
				}
		},
		mounted(){
			
			
		},
		methods:{
			changeStatus(){
				if(this.isauto==1){
					this.isauto=0
				}else{
					this.isauto=1;
				}
			},
			closeFlag(){
				
			},
			gotoCharge(){
				if(this.countCurrency<=this.userCurrency){
					this.$emit('autobuyChange',{data:1,isauto:this.isauto})//确认订购
				}else{
					this.$emit('autobuyChange',{data:2,isauto:this.isauto})//充值
					}
			},
			closeMask(){
				this.$emit('autobuyChange',false)
				this.isModalflag=false;
			}
		},
		}
</script>

<style scoped>
	.pop-mask{
		position:fixed;
		left:0px;
		background-color:rgba(0,0,0,.5);
		width:100%;
		height:100%;
		top:0px;
		z-index:10001;
	}
	.mask-content{
		width:100%;
		height:274px;
		box-sizing:border-box;
		background-color:#fff;
		position:absolute;
		left:0px;
		bottom:0px;
		border-radius:30px 30px 0px 0px; 
		text-align:center;
		/* height:calc(48px + env(safe-area-inset-bottom)); */
		padding-bottom:calc(17px +  constant(safe-area-inset-bottom));
		/* 兼容 iOS < 11.2 */
		padding-bottom:calc(17px +env(safe-area-inset-bottom));
	}
	.mask-content>span{
		font-size: 22px;
		color: #333333;
		margin-top: 18px;
		padding-bottom:18px;
		margin-bottom:18px;
		display:block;
		border-bottom:1px solid  #F3F3F3;
	}
	.mask-content>div{
		padding:0px 30px;
		display:flex;
		    justify-content: space-between;
			font-size: 16px;
			color: #333333;
			margin-bottom: 21px;
	}
	.mask-content>div.btn{
		background: #EC4C4C;
		border-radius: 100px;
		height:50px;
		width: 306px;
		margin:0 auto;
		color:#fff;
		text-align:center;
		line-height:50px;
		display:block;
		padding:0px;
		margin-bottom:16px;
		margin-top:5px;
		font-size: 18px;
	}
	.tips>img{
		width:12px;
		height: 12px;;
	}
	.tips>span{
		font-size: 12px;
color: #888888;
	}
</style>



// WEBPACK FOOTER //
// src/view/components/autoBuy.vue